import React, {Fragment} from "react";
import { withStyles } from "@material-ui/core/styles";
import FormGroup from '@material-ui/core/FormGroup';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import IndeterminateCheckBox from '@material-ui/icons/IndeterminateCheckBox';
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import NumericFilters from "./numericOperatorFilter";
import ExpandIcon from "@material-ui/icons/ExpandMore";
import Clear from "@material-ui/icons/CancelOutlined";

const styles = theme => ({
    filterContainer:{
        maxWidth:"180px",
        maxHeight: "230px",
        padding: theme.spacing.unit,
        backgroundColor: theme.ModalBGColor,
        overflow:"hidden",
        '& label$checkbox_root$formControlLabel':{
            display:"flex",
            color: theme.TextColor
        },
        '& $searchInputRoot>$searchInput[type="text"]':{
            border:"none",
            color: theme.TextColor,
            height:24,
            '&:focus':{
                border:"none"
            },
            '&::placeholder':{
                color:theme.TextColor,
                opacity: "0.5"
            }
        }
    },
    checkbox_root: {
        padding: "5px",
        paddingLeft:"0px",
        verticalAlign: "middle",
        height: "100%",
        color: theme.gridIconBorderColor,
        '&$checkbox_checked': {
          color: theme.HeaderSelectedText
        }
      },
      checkbox_checked: {
      },
      checkbox_disabled:{

      },
      formControlLabel:{
          margin:0,
          backgroundColor: theme.ModalBGColor,
          paddingBottom: "0",
          listStyleType:"none",
          display:"flex",
          cursor:"pointer",
          paddingTop:"5px",
          '& $formControlLabelDisabled,& $checkbox_disabled':{
            color:"inherit",
            opacity:"0.5",
          }
      },
      labelDisabled:{
        cursor:"not-allowed"
      },
      formControlLabelDisabled:{
        color:"inherit",
        opacity:"0.5",
        pointerEvents: "none"
      },
      formControlLabelColor: {
        fontSize: "12px",
        color: theme.TextColor,
        marginTop:"5px"
      },
      button: {
        margin: theme.spacing.unit,
        textTransform: "none",
        flex: "1 1 auto",
        padding:"0",
        minWidth: "45px",
        minHeight: "15px"
      },
      list:{
          maxHeight: "130px",
          overflow:"auto",
          paddingLeft:"10px",
          margin: "0",
          '&  $checkbox_root':{
              paddingLeft: "5px"
          }
      },
      numericFilterContainer:{
          backgroundColor:  theme.ModalBGColor,
          display: "inline-grid",
          gridTemplateColumns: "0.75fr 2fr",
          justifyContent:"space-between",
          '&>div':{
            marginRight: "5px"
          }
      },
      multipleInputContainer:{
        gridTemplateColumns: "0.75fr 1fr 1fr"
      },
      paperStyle:{
        backgroundColor: theme.ModalBGColor,
        marginTop: "40px"
      },
      menuItem:{
        paddingTop: "5px",
        paddingBottom: "5px",
        color: theme.TextColor
      },
      selectInput:{
        color: theme.TextColor,
        fontSize: "16px",
        padding: 0,
        paddingLeft:"5px",
        '& ~ $iconStyle':{
            paddingTop: "3px"
        }
      },
      numericInput:{
        paddingLeft:"5px",
        color: theme.TextColor,
        fontSize: "12px",
        height: 24
      },
      selectedColorText:{
        color: theme.HeaderSelectedText
      },
      colorText:{
       color: theme.TextColor,
       '&$selectedColorText':{
            color: theme.HeaderSelectedText
        }
      },
      noOptions:{
          width:"100%",
          height: "100%",
          fontSize: "12px",
          textAlign:"center",
          opacity: 0.6,
          color: theme.TextColor
      },
      iconStyle:{
          fontSize: "16px",
          color: theme.iconColor,
          cursor: "pointer"
      },
      searchInputRoot:{
        fontSize: "12px",
        borderBottom:`1px solid ${theme.iconColor}`,
        width:"100%"
      },
      searchInput:{
          fontSize: "12px",
          border:"none"
      },
      inputLabel:{
        fontSize: "12px",
        color: theme.TextColor,
        opacity: 0.6
      },
      searchInputFocused:{
        borderColor: theme.HeaderSelectedText,
        borderWidth: "2px"
      },
      underlineStyle:{
          borderColor: theme.iconColor
      }
});

const MultiSelectComponent = props => {
    const { classes, options } = props;
    const isSelectAllDisabled = options.length === 0;
    const hasSelections = props.options.filter(option=>option.checked).length > 0;
    const hasNumericRange = props.numericOperator && props.numericOperator.needsRange;
    function onNumericFieldKeyPress(event){
        if(!((event.charCode == 8 || event.charCode == 0 ) ? null : (event.charCode >= 48 && event.charCode <= 57 || [45, 46].includes(event.charCode)))){
            event.preventDefault();
        }
    }
    return (
        <div className={classes.filterContainer}>
            { !props.isNumericFilter ? (
                <InputBase
                    placeholder="Search…"
                    classes={{
                        root: classes.searchInputRoot,
                        input: classes.searchInput,
                        focused: classes.searchInputFocused
                    }}
                    value={props.searchTerm}
                    onChange={(event) => props.onSearch(event.target.value)}
                    endAdornment={
                        <Fragment>
                         { props.searchTerm ? <Clear className={classes.iconStyle} onClick={() => props.onSearch("")}/> : ""}
                         <SearchIcon className={classes.iconStyle}/>
                        </Fragment>
                    }
                />
             ) : (
                <FormGroup className={`${classes.numericFilterContainer} ${hasNumericRange ? classes.multipleInputContainer : ""}` }>
                    <Select
                        value={props.numericOperator.value}
                        onChange={(event, child) => props.numericOperatorUpdated(child.props.operator)}
                        IconComponent={ExpandIcon}
                        classes={{
                            select: classes.selectInput,
                            icon: classes.iconStyle,
                        }}
                        MenuProps={{
                            disablePortal: true,
                            PopoverClasses:{
                                paper: classes.paperStyle
                            }
                        }}
                    >
                        {
                            NumericFilters.map(filter=>(
                                <MenuItem key={filter.value} value={filter.value} operator={filter} classes={{root: classes.menuItem, selected: classes.selectedColorText}}>{filter.label}</MenuItem>
                            ))
                        }
                    </Select>
                    <TextField
                        label={`${hasNumericRange ? "From" : ""}`}
                        InputProps={{
                            placeholder:`${hasNumericRange ? "" : "Numeric Value" }`,
                            classes:{
                                input: classes.numericInput,
                                underline: classes.underlineStyle
                            }
                        }}
                        InputLabelProps={{
                            classes:{
                                root: classes.inputLabel
                            }
                        }}
                        inputProps={{
                            min:0,
                            onKeyPress: onNumericFieldKeyPress
                        }}
                        type="number"
                        value={props.startRange}
                        onChange={(event)=> props.numericRangeUpdate("startRange",event.target.value)}
                    />
                    {props.numericOperator && props.numericOperator.needsRange && (
                    <TextField
                        label="To"
                        InputProps={{
                            classes:{
                                input: classes.numericInput,
                                underline: classes.underlineStyle
                            }
                        }}
                        InputLabelProps={{
                            classes:{
                                root: classes.inputLabel
                            }
                        }}
                        inputProps={{
                            min:0,
                            onKeyPress: onNumericFieldKeyPress
                        }}
                        type="number"
                        value={props.endRange}
                        onChange={(event)=>props.numericRangeUpdate("endRange",event.target.value)}
                    />
                    )}
                </FormGroup>
            )}
                <div className={`${isSelectAllDisabled ? classes.labelDisabled : ""}`}>
                <div onClick={()=>props.onSelectAll(!hasSelections)} className={`${classes.formControlLabel} ${isSelectAllDisabled ? classes.formControlLabelDisabled : ''}`}>
                    <span className={`${classes.checkbox_root} ${hasSelections ? classes.checkbox_checked :'' }`}>
                        {hasSelections ?
                            <IndeterminateCheckBox color="primary"/> :
                            <CheckBoxOutlineBlankIcon />
                        }
                    </span>
                    <span className={classes.formControlLabelColor}>{  hasSelections ? "CLEAR ALL" : "SELECT ALL"}</span>
                </div>
                </div>
                <ul className={classes.list}>
                { options.length ? options.map(option =>(
                    // Not using the default Checkbox here due to performance Lags
                    <li key={option.value} onClick={()=>props.onOptionSelected({...option, checked:!option.checked})} className={`${classes.formControlLabel}`}>
                        <span key={`Checkbox`} className={`${classes.checkbox_root} ${option.checked ? classes.checkbox_checked :'' }`}>
                                {option.checked ?
                                    <CheckBoxIcon color="primary" /> :
                                    <CheckBoxOutlineBlankIcon />
                                }
                        </span>
                        <span key={`label`}  className={classes.formControlLabelColor}>{option.label}</span>
                    </li>
                )) : <div className={classes.noOptions}> NO RESULTS </div>}
                </ul>
        </div>
    )
}

export default withStyles(styles)(MultiSelectComponent);